// extracted by mini-css-extract-plugin
module.exports = {"container":"SetupOverview_container__3_AoD","setup":"SetupOverview_setup__2-w8_"};